import React, { useState, useEffect } from 'react';
import styles from './interviewConfigurations.module.scss';
import Select from 'react-select'
import * as yup from 'yup';
import { Formik } from 'formik';
import makeAnimated from 'react-select/animated';
import { Col, Row, Form } from 'react-bootstrap';
import { getAllReviewers } from '../../../../../../services/util/userManagement';

import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { CustomDropdown } from '../../../../../shared/customDropdown';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomTextArea } from '../../../../../shared/customTextArea';
import ReactTooltip from 'react-tooltip';

const InterviewConfigurations = (props) => {
    let [options, setOptions] = useState([]);
    let [allTimeZones, setAllTimeZones] = useState();
    let [allReviwers, setallReviewers] = useState(props.interviewers);
    let [timeZone, setTimeZone] = useState(props.timeZone.value);
    const animatedComponents = makeAnimated();
    const dropValue = [
        {
            label: 'Online Interview',
            value: 0,
        },
        {
            label: 'Physical Interview',
            value: 1,
        },
    ]
    let moment = require('moment-timezone');

    //yup validations
    const schema = yup.object({
        interviewers: yup.array().typeError('Required').required('Required').nullable(),
        dateTime: yup.string().test('date check', 'Past Dates Not Accepted', function (item) {

            let setDate = moment(item).format("YYYY-MM-DD HH:mm");
            let setDateObj = moment.tz(setDate, timeZone);
            let currentDate = moment().tz(timeZone);

            if (setDateObj > currentDate) {
                return true;
            } else {
                return false;
            }
        }).required('Required'),
        address: yup.string().when('interviewType', { is: (value) => value === 1, then: yup.string().required('Required'), otherwise: yup.string().nullable('Required').typeError('Required') }),
        guidelineDescription: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').nullable(),
    });

    //check validity of dates
    let yesterday = moment().tz(timeZone).subtract(1, 'day');
    let valid = function (current) {
        return current.isAfter(yesterday);
    };

    //on submit function
    const onSubmit = async (values) => {
        props.updateValues({ dateTime: values.dateTime, interviewType: values.interviewType, address: values.address, interviewers: values.interviewers, timezone: values.timezone, guidelineDescription: values.guidelineDescription });
        props.nextPage(2)
    }

    const changeType = (value) => {
        let number = parseInt(value)
        props.updateInterviewType(number)
    }

    const changeTimeZone = (e) => {
        setTimeZone(e.value)
    }


    useEffect(() => {
        let unmounted = false;
        const setInitialValues = async () => {
            if (!unmounted) {
                let array = [];
                let reviewers = [];
                let values = moment.tz.names();
                let reviewesList = await getAllReviewers();
                values.forEach(value => {
                    array.push({
                        value: value,
                        label: value
                    })
                });
                reviewesList.data.forEach(value => {
                    reviewers.push({
                        _id: value._id,
                        user_id: {
                            email: value.user_id.email,
                            name: value.user_id.first_name + ' ' + value.user_id.last_name
                        }
                    });
                });
                setOptions(reviewers)
                setAllTimeZones(array);
            }
        }

        setInitialValues();
        return () => { unmounted = true };
    }, []);


    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ timezone: props.timeZone, dateTime: props.values.shedule_date ? moment(props.values.shedule_date).format("YYYY-MM-DD HH:mm"): moment.tz(props.values.schedule_date_time_utc, props.values.time_zone).format("YYYY-MM-DD HH:mm"), interviewers: allReviwers, interviewType: props.values.interview_type, address: props.values.interview_location_address, guidelineDescription: props.values.guidelineDescription }}>

                {({
                    values,
                    errors,
                    setFieldValue,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <div>
                            <div className="mb-2">
                                <Form.Label className={styles.defaultLabel}>
                                    Interviewers
                                </Form.Label>
                                <Select options={options}
                                    defaultValue={values.interviewers}
                                    isMulti
                                    name="interviewers"
                                    class="react-select__control"
                                    components={animatedComponents}
                                    onChange={(e) => { setFieldValue('interviewers', e); }}
                                    getOptionValue={option => `${option._id}`}
                                    getOptionLabel={options => `${options.user_id.email} - ${options.user_id.name}`}
                                    styles={
                                        errors.interviewers === 'Required' ?
                                            {
                                                ...styles,
                                                control: (base, state) => ({
                                                    ...base,
                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                    border: '1px solid #dc3545', // default border color
                                                    borderRadius: '6px',
                                                    boxShadow: 'none', // no box-shadow
                                                }),
                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                    return {
                                                        ...styles,
                                                        background: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                : isFocused
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? '#24859A'
                                                                : '#24859A',
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            background:
                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                        },
                                                    };
                                                },
                                            }
                                            :
                                            {
                                                ...styles,
                                                control: (base, state) => ({
                                                    ...base,
                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                    border: '1px solid #bdbdbd', // default border color
                                                    borderRadius: '6px',
                                                    boxShadow: 'none', // no box-shadow
                                                }),
                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                    return {
                                                        ...styles,
                                                        background: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                : isFocused
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? '#24859A'
                                                                : '#24859A',
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            background:
                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                        },
                                                    };
                                                },
                                                multiValue: (styles) => {
                                                    return {
                                                        ...styles,
                                                        background: 'rgba(45, 166, 192, 0.1)',
                                                    };
                                                },
                                                multiValueLabel: (styles) => ({
                                                    ...styles,
                                                    color: '#24859A',
                                                }),
                                                multiValueRemove: (styles) => ({
                                                    ...styles,
                                                    color: '#24859A',
                                                    ':hover': {
                                                        backgroundColor: '#24859A',
                                                        color: 'white',
                                                    },
                                                }),
                                            }
                                    }
                                />
                                <p className={styles.errorMsg}>{errors.interviewers}</p>
                            </div>

                            <div className="mb-2">
                                <Form.Label className={styles.defaultLabel}>
                                    Time Zone
                                </Form.Label>
                                <Select
                                    options={allTimeZones}
                                    name="timezone"
                                    class="react-select__control"
                                    components={animatedComponents}
                                    value={values.timezone}
                                    onChange={(e) => { setFieldValue('timezone', e); changeTimeZone(e) }}
                                    styles={
                                        {
                                            ...styles,
                                            control: (base, state) => ({
                                                ...base,
                                                '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                border: '1px solid #bdbdbd', // default border color
                                                borderRadius: '6px',
                                                boxShadow: 'none', // no box-shadow
                                            }),
                                            option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                return {
                                                    ...styles,
                                                    background: isDisabled
                                                        ? null
                                                        : isSelected
                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                            : isFocused
                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                : null,
                                                    color: isDisabled
                                                        ? '#ccc'
                                                        : isSelected
                                                            ? '#24859A'
                                                            : '#24859A',
                                                    cursor: isDisabled ? 'not-allowed' : 'default',

                                                    ':active': {
                                                        ...styles[':active'],
                                                        background:
                                                            !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                    },
                                                };
                                            },
                                        }
                                    }
                                />
                            </div>

                            <div className="mb-2">
                                <Form.Label className={styles.defaultLabel}>
                                    Date and Time
                                </Form.Label>
                                <Datetime
                                    value={values.dateTime}
                                    isValidDate={valid}
                                    inputProps={{ readOnly: true }}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat ="HH:mm"
                                    onChange={(e) => { setFieldValue('dateTime', e); }}
                                    className={
                                        ((submitCount > 0 && errors.dateTime === 'Required') || (submitCount > 0 && errors.dateTime === 'Past Dates Not Accepted')) ?
                                            styles.errorBorder
                                            : styles.normalBorder
                                    }
                                />
                                {submitCount > 0 && errors.dateTime &&
                                    <p className={styles.errorMsg}>{errors.dateTime}</p>
                                }

                            </div>

                            <div>
                                <CustomDropdown
                                    label="Interview Type"
                                    controlId="interviewType"
                                    name="interviewType"
                                    value={values.interviewType}
                                    handleOnChange={(e) => { setFieldValue('interviewType', parseInt(e.target.value)); changeType(e.target.value) }}
                                    dropdownValues={dropValue}
                                    errorMessage={errors.interviewType}
                                    isInvalid={submitCount > 0 && !!errors.interviewType}
                                />
                            </div>
                            {
                                props.values.interview_type === 1 &&
                                <div>
                                    <CustomTextField
                                        label="Interview Location Address "
                                        name="address"
                                        classLabel="defaultLabel"
                                        controlId="address"
                                        type="text"
                                        value={values.address}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.address}
                                        isInvalid={submitCount > 0 && !!errors.address}
                                    />
                                </div>
                            }
                            <div>
                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                    <Form.Label className={styles.textareaLabel}>
                                        Interview Guideline&nbsp;(&nbsp;For&nbsp;Candidates&nbsp;)&nbsp;
                                        <svg data-tip data-for={`interviewGuideline`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id={`interviewGuideline`} place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p> A guideline for candidates to prepare for the interview.</p>}</div>
                                        </ReactTooltip>

                                    </Form.Label>

                                    {/* <Form.Control as="textarea" name="guidelineDescription" value={values.guidelineDescription} onChange={handleChange} rows={3} className={styles.textareaBox} placeholder={"Ex: This is a technical interview so get ready for technical questions."} /> */}
                                    <CustomTextArea
                                        name="guidelineDescription"
                                        values={values.guidelineDescription}
                                        errorMessage={errors.guidelineDescription}
                                        handleChange={handleChange}
                                        isInvalid={submitCount > 0 && !!errors.guidelineDescription}
                                        placeholder={"Ex: This is a technical interview so get ready for technical questions."}
                                    // remainingCount={(values.guidelineDescription).length}
                                    // maxLength={800}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div sm={12} className={styles.loginBtnCol}>
                            <Row>
                                <Col>
                                    <CustomButton
                                        buttonType="submit"
                                        label="Next"
                                        type="primaryBtn"
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default InterviewConfigurations;
